module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_kit-e702206d8d129f6260bf776be0117af3.jpg";